import { Store } from '@src/application/store/store';
import { StateDefinition } from '@src/application/store/state-definition';
import { LegacyStore } from '@src/application/store/legacy-store-interface.ts';
import Modal from '@src/application/modal.ts';

const store = new Store({
    modals: new StateDefinition([], false),
});

export default store as unknown as LegacyStore<Array<Modal>>;
